/*
 * spurtcommerce
 * version 4.3
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,

    storeUrl: 'http://157.230.179.86:3000/api/',
    imageUrl: 'http://157.230.179.86:3000/api/media/image-resize',
    // storeUrl: 'http://localhost:8000/api/',
    // imageUrl: 'http://localhost:8000/api/media/image-resize',

    storename: '220 Volt',
    settingsId: 3,
    Url:'http://192.241.196.90/'

    // storename: 'East West',
    // settingsId: 2,
    // Url:'http://157.230.179.86'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

